<template>
    <div>
        <ValidationObserver ref="formModalValidate">
           <b-row>
               <b-col cols="12" md="6">
                   <ValidationProvider name="student_club_id" rules="required" v-slot="{ valid, errors }">
                       <b-form-group :label="$t('club')">
                           <student-club-selectbox v-model="form.student_club_id"
                                                     :validate-error="errors[0]">
                           </student-club-selectbox>
                       </b-form-group>
                   </ValidationProvider>
               </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="academic_year" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox v-model="form.academic_year"
                                                      :activeYears="true"
                                                      :validate-error="errors[0]"></academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                   <ValidationProvider name="type" rules="required" v-slot="{ valid, errors }">
                       <b-form-group :label="$t('type')">
                           <parameter-selectbox v-model="form.type" code="student_club_vote_types" />
                           <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                       </b-form-group>
                   </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="name" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('title')">
                            <b-form-input :validate-error="errors[0]" v-model="form.name"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                   <ValidationProvider name="start_date" rules="required" v-slot="{ valid, errors }">
                       <b-form-group :label="$t('start_date')">
                           <select-date v-model="form.start_date" :is-time="true" :state="errors[0] ? false : null" />
                           <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                       </b-form-group>
                   </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                   <ValidationProvider name="end_date" rules="required" v-slot="{ valid, errors }">
                       <b-form-group :label="$t('end_date')">
                           <select-date v-model="form.end_date" :is-time="true" :state="errors[0] ? false : null" />
                           <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                       </b-form-group>
                   </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="description" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('description')">
                            <b-form-textarea v-model="form.description"
                                             :class="errors[0] ? 'is-invalid':''"
                                             rows="5"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox v-model="form.status" code="student_club_vote_statuses" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-button
                @click="createForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
    import AcademicYearsSelectbox from '@/components/interactive-fields/AcademicYearsSelectbox.vue';
    import StudentClubSelectbox from "@/components/interactive-fields/StudentClubSelectbox.vue";

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import StudentClubVoteService from "@/services/StudentClubVoteService";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,

            ParameterSelectbox,
            AcademicYearsSelectbox,
            StudentClubSelectbox,
        },
        data() {
            return {
                formLoading: false,
                form: {
                    student_club_id: null,
                    academic_year: null,
                    type: null,
                    name: null,
                    start_date: null,
                    end_date: null,
                    description: null,
                    status: null,
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;
                    StudentClubVoteService.store(this.form)
                                    .then((response) => {
                                        this.$toast.success(this.$t("api." + response.data.message));
                                        this.$emit("createFormSuccess")
                                    })
                                    .catch((error) => {
                                        this.showErrors(error, this.$refs.formModalValidate)
                                    }).finally(() => {
                        this.formLoading = false;
                    });
                }
            }
        }
    }
</script>
